import { fetchProject, ProjectWithRole } from '@neptune/shared/core-project-domain';

import { AsyncActionsReturnType, createAsyncActions } from 'state/async-actions';

export enum FetchCurrentProjectActionTypes {
  request = 'CURRENT_PROJECT_FETCH',
  success = 'CURRENT_PROJECT_FETCH_SUCCESS',
  fail = 'CURRENT_PROJECT_FETCH_FAIL',
}

const actions = createAsyncActions({
  types: FetchCurrentProjectActionTypes,
  resolver({ projectIdentifier }: { projectIdentifier: string }): Promise<ProjectWithRole> {
    return fetchProject({ projectIdentifier });
  },
});

export const { execute: fetchCurrentProject } = actions;
export type CurrentProjectAction = AsyncActionsReturnType<typeof actions>;
